import React from "react";
import "../../styles/payment-method.css";
import paystack from "../../assets/all-images/paystack.png";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { usePaystackPayment } from 'react-paystack';

const PaymentMethod = ({ amount }) => {
  const navigate = useNavigate(); // Use useNavigate for navigation

  const config = {
    reference: (new Date()).getTime().toString(),
    email: 'olivehendendrilgen1@gmail.com',
    amount: 1000,
    publicKey: 'pk_live_abb46c94037e7ed68475a89415ebcb2fd5b3dbc5',
    currency: 'KES',
    channels: ['card', 'mobile_money'],
  };

  const onSuccess = (reference) => {
    navigate("/cars"); // Navigate to "/cars" page
  };

  const onClose = () => {
    
  };

  const initializePayment = usePaystackPayment(config);

  const handleReserveNow = () => {
    initializePayment(onSuccess, onClose);
  };

  return (
    <>
      <div className="payment mt-3 d-flex align-items-center justify-content-between">
        <img src={paystack} alt="" />
      </div>
      <div className="payment text-end mt-5">
        <button onClick={handleReserveNow}>Reserve Now</button>
      </div>
    </>
  );
};

export default PaymentMethod;
